import { Inject, Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { EVENT, HistoryEventService } from './history.event.service';
import { AccountService } from './account';
import { LogService } from './log.service';

@Injectable({
  providedIn: 'root',
})
export class HistoryService {
  private httpClient = inject(HttpClient);
  private accountService = inject(AccountService);
  private logService = inject(LogService);

  constructor(
    @Inject('BASE_URL') private baseUrl: string,
    public historyEventService: HistoryEventService
  ) {
  }

  /**
   * Получение списка покупок (история платежей)
   */
  getPaymentsHistory(withEvent: boolean): Observable<PaymentHistory[]> {
    return new Observable(subscriber => {
      this.accountService.checkExpireToken("HistoryService.getPaymentsHistory").subscribe(res => {
        return this.httpClient.get<PaymentHistory[]>(this.baseUrl + '/v1/payment', {
          headers: {
            'X-Account-Id': this.accountService.getAccountId(),
            'Authorization': 'Bearer ' + this.accountService.getAccessToken(),
          },
        })
          .subscribe(data => {
            subscriber.next(data);
            subscriber.complete();
            if (withEvent) {
              this.logService.LogMessage("Ответ GET /v1/payment получен. Отправка события для обновления списка");
              this.historyEventService.setEvent('history');
            }
          });
      });
    })
  }
}
